<template>
  <div class="pc-note__tab-sidebar" v-show="sidebarVisible" v-if="!isOpenedEmpty" @wheel="onWheelHandler">
      <pannel v-if="hasNotebook" v-show="active === 'catalog'">
        <catalog-header slot="header" />
        <catalog />
      </pannel>
      <pannel v-if="hasNote" v-show="active === 'outline'">
        <outline-header slot="header"/>
        <outline />
      </pannel>
      <pannel v-if="hasNote" v-show="active === 'note_details'">
        <note-details-header slot="header"/>
        <note-details />
      </pannel>
      <pannel v-if="hasNotebook" v-show="active === 'notebook_details'">
        <notebook-details-header slot="header"/>
        <notebook-details />
      </pannel>
      <pannel v-show="active === 'opened'">
        <opened-list-header slot="header"/>
        <opened-list />
      </pannel>
      <tools/>
  </div>
</template>

<script>
import OutlineHeader from '@/components/note/sidebar/OutlineHeader.vue'
import OpenedListHeader from '@/components/note/sidebar/OpenedListHeader.vue'
import Outline from '@/components/note/sidebar/Outline.vue'
import OpenedList from '@/components/note/sidebar/OpenedList.vue'
import NoteDetails from '@/components/note/sidebar/Details.vue'
import NoteDetailsHeader from '@/components/note/sidebar/DetailsHeader.vue'
import NotebookDetails from '@/components/note/sidebar/NotebookDetails.vue'
import NotebookDetailsHeader from '@/components/note/sidebar/NotebookDetailsHeader.vue'
import { mapGetters, mapMutations } from 'vuex'
import CatalogHeader from '@/components/note/sidebar/CatalogHeader.vue'
import Catalog from '@/components/note/sidebar/Catalog.vue'
import Tools from '@/components/note/sidebar/Tools.vue'
import Pannel from '@/components/note/sidebar/Pannel.vue'
import _ from 'lodash'

export default {
  components: {
    OutlineHeader,
    OpenedListHeader,
    Outline,
    OpenedList,
    NoteDetails,
    NoteDetailsHeader,
    NotebookDetails,
    NotebookDetailsHeader,
    CatalogHeader,
    Catalog,
    Tools,
    Pannel
  },
  data () {
    return {
      onWheelThrottle: _.throttle(this.changeSidebarTab, 500)
    }
  },
  computed: {
    ...mapGetters({
      sidebarVisible: 'workbench/sidebarVisible',
      isOpenedEmpty: 'workbench/opened/isEmpty',
      active: 'workbench/current/sidebarActive'
    }),
    hasNote () {
      return this.$route.params.noteId !== undefined
    },
    hasNotebook () {
      return this.$route.params.notebookId !== undefined
    }
  },
  methods: {
    ...mapMutations({
      setSidebarActive: 'workbench/current/SET_SIDEBAR_ACTIVE'
    }),
    changeSidebarTab (event) {
      if (!event.shiftKey) {
        return
      }

      let list
      if (this.hasNote && this.hasNotebook) {
        list = ['outline', 'catalog', 'opened', 'note_details', 'notebook_details']
      } else if (this.hasNote) {
        list = ['outline', 'opened', 'note_details']
      } else if (this.hasNotebook) {
        list = ['catalog', 'opened', 'notebook_details']
      }
      const currentActiveIndex = _.indexOf(list, this.active)
      let nextActiveIndex
      const isDown = event.deltaY > 0
      if (isDown) {
        if (currentActiveIndex === list.length - 1) {
          nextActiveIndex = 0
        } else {
          nextActiveIndex = currentActiveIndex + 1
        }
      } else {
        if (currentActiveIndex === 0) {
          nextActiveIndex = list.length - 1
        } else {
          nextActiveIndex = currentActiveIndex - 1
        }
      }

      this.setSidebarActive(list[nextActiveIndex])
    },
    onWheelHandler (event) {
      this.onWheelThrottle(event)
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/variables.scss';

.pc-note__tab-sidebar {
  min-width: 30rem;
  width: 30rem;
  border-right: 1px solid $border-color-structure;
  overflow: auto;
  display: flex;
  flex-direction: column;
}
.pc-note__sidebar-header {
  position: sticky;
  height: 2.6rem;
  min-height: 2.6rem;
  border-top: 1px solid $border-color-light;
  border-bottom: 1px solid $border-color-light;
  display: flex;
  flex-direction: row;
  font-size: 1.2rem;
  align-items: center;
  color: $color-b3;
  user-select: none;
  background: white;
  cursor: pointer;
  padding: 0 .5rem;
  z-index: 1;

  .fold,.unfold {
    line-height: 1;
    width: 1.6rem;
  }

  .name {
    line-height: 1;
  }

  .tools {
    flex-direction: row-reverse;
    display: flex;
    width: 0;
    flex-grow: 1;

    .pc-icon {
      margin-left: .5rem;
      width: 2rem;
      height: 2rem;
    }
  }
}

// .pc-note__sidebar-pannel:first-of-type .pc-note__sidebar-header {
//   border-top: none;
// }

.pc-note__sidebar-header:first-of-type {
  border-top: none;
}

.pc-note__sidebar-details {
  // height: 0;
  // flex-grow: 1;
  // overflow: auto;
  // margin-bottom: 1rem;

  & > .header {
    padding: .5rem 0;
    color: $color-b3;
  }

  .tag {
    margin: 0 .5rem .5rem 0;
    font-size: 1.2rem;
    height: unset;
    word-break: break-all;
    white-space: unset;
    line-height: 1.6rem;
    padding: .5rem .5rem .5rem 1rem;
    background-color: #ecf5ff;
    border: 1px solid #d9ecff;
    border-radius: .4rem;
    color: $color-main;
    display: inline-flex;
  }

  .tag-remove {
    margin-left: .5rem;
    width: 1.6rem;
    min-width: 1.6rem;
    height: 1.6rem;
    min-height: 1.6rem;
    border-radius: 50%;
    text-align: center;
    transition: background-color .15s linear, color .15s linear;
  }
  .tag-remove:hover {
    background: $color-main;
    color: white;
    cursor: pointer;
  }

  .el-button {
    line-height: 1.6rem;
    padding: .5rem 1rem;
  }

  .el-input--small {
    height: unset;
  }
  .el-input--small .el-input__inner {
    height: unset;
    padding: .5rem 1rem;
    line-height: 1.6rem;
    font-size: 1.2rem;
  }

  & > .content {
    padding-bottom: 1rem;

    p {
      margin-bottom: .5rem;
    }
  }
}
</style>
